import React from 'react';
import CardItem from "./CardItem";
import { Link } from "react-router-dom";
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/scrollbar';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import '../../../../Assets/Css/swiper.css'
import { Keyboard, Scrollbar, Navigation, Pagination,Autoplay } from 'swiper/modules';
/*import Browse from "../Browse";*/
export default function SectionContent(props) {
    const {type,title,id} = props

    return (
        <div className='flex flex-col mb-12'>
            <div className="flex flex-row justify-between items-center transition w-full mb-6">
                <div className='text-violet-800 font-black text-base md:text-lg'>{title}</div>
                <Link to={'browse'} state={{title: title}}>
                    <button
                        className='text-violet-600 text-sm font-medium'
                    >
                        مشاهده بیشتر
                    </button>
                </Link>

            </div>
            <Swiper
                slidesPerView={2}
                spaceBetween={0}
                centeredSlides={false}
                slidesPerGroupSkip={1}
                grabCursor={false}
                keyboard={{
                    enabled: true,
                }}
                breakpoints={{
                    450: {
                        slidesPerView: 3,
                        // spaceBetween:30
                    },
                    640: {
                        slidesPerView: 4,
                        spaceBetween:20
                    },
                    769: {
                        slidesPerView: 5,
                        spaceBetween:20
                    },
                    1224: {
                        slidesPerView: 7,
                        spaceBetween:0
                    },
                }}
                loop={true}
                direction={"horizontal"}
                freeMode={true}
                // autoplay={{ delay: 3000, disableOnInteraction: false }}
                modules={[Keyboard, Scrollbar, Navigation, Pagination,Autoplay]}
                className={"!pl-2 xs:!pl-16 sm:!pl-12 md:!pl-10 lg:!pl-16"}
            >
                {
                    props.products?.map((product,index) =>
                        <SwiperSlide>
                            <Link to={`${type}/${product.id}`} >
                                <CardItem name={product.name} artist={product.artist}/>
                            </Link>
                        </SwiperSlide>
                    )
                }
            </Swiper>

        </div>
    );
}